import { render } from "./SampleInformationTabs.vue?vue&type=template&id=d9926682"
import script from "./SampleInformationTabs.vue?vue&type=script&lang=js"
export * from "./SampleInformationTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__